import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email } from "vuelidate/lib/validators";

const file_size_validation = (value, vm) => {
  if (!value || !value.size) {
    return true;
  }
  let file = value;
  return file.size < 1048576;
};
const image_type_validation = (value, vm) => {
  if (!value || !value.size) {
    return true;
  }
  let file = value;
  if (
    file.type == "image/svg+xml" ||
    file.type == "image/jpeg" ||
    file.type == "image/gif" ||
    file.type == "image/png"
  ) {
    return true;
  } else {
    return false;
  }
};

export default {
  components: {},
  data() {
    return {
      ShowLoader: false,
      Saving: false,
      submitted: false,
      SearchKey: "",
      RowId: 0,
      Modules: [],
      Permissions: ["enable"],
      EditRole: {
        title: "",
        permissions: {},
      },
      selectAllRole: false,
      currentModules:[]
    };
  },
  validations: {
    EditRole: {
      title: { required },
    },
  },
  mounted() {
    document.title = pbx_SiteTitle + " - User Add";
    this.RowId = this.$route.params.RowId;
    this.GetModules();
  },

  methods: {
    GetModules() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Modules.List, obj).then((Response) => {
        if (Response.data.success) {
          this.currentModules = Response.data.records;
          Response.data.records.forEach((element) => {
            this.EditRole.permissions[element] = {};
              this.Permissions.forEach((Permission) => {
                this.EditRole.permissions[element][Permission] = false;
              });
          });
          setTimeout(() => {
            this.Modules = Response.data.records;
            this.GetRoleDetail();
          }, 400);
        }
      });
    },
    GetRoleDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Roles.Get, {
        token: localStorage.getItem("token"),
        id: this.RowId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response.data.success) {
          var getRoleData = Response.data.record;
            this.EditRole.id = getRoleData.id;
            this.EditRole.title = getRoleData.title;

           // getRoleData.permissions = JSON.parse(getRoleData.permissions);

            this.currentModules.forEach((element) => {
              if (typeof getRoleData.permissions[element] != "undefined") {
                this.EditRole.permissions[element] =
                  getRoleData.permissions[element];
              }
            });
        }
      });
    },
    UpdateRole() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.Saving = true;
      Axios.post(Endpoints.Roles.Update, {
        token: localStorage.getItem("token"),
        ...this.EditRole,
      }).then((Response) => {
        if (Response.data.success) {
          this.$swal
            .fire("Role Updated Successfully", "", "success")
            .then(() => {
              this.$router.push("/account-roles/");
            });
        } else {
          this.$swal.fire({
            title: "Oops!",
            text: Response.data.message,
            icon: "error",
            confirmButtonText: "Close",
          });
          this.Saving = false;
        }
      });
    },
    selectAllRoles() {
      if (this.selectAllRole == true) {
        this.selectAllRole = false;
      } else {
        this.selectAllRole = true;
      }
      this.Modules.forEach((element) => {
        if (typeof this.EditRole.permissions[element] != "undefined") {
          Object.keys(this.EditRole.permissions[element]).forEach(
            (Permission) => {
              this.EditRole.permissions[element][Permission] =
                this.selectAllRole;
            }
          );
        }
      });
    },
  },
};
